import { isEmpty } from "lodash";
import { decrypt, encrypt } from "./encryption";
import { client } from "./global";

export enum LocalStorageKey {
  Token = "token",
  NavigateId = "navigateId",
  User = "user",
  CounterUjian = "counterUjian",
  SavedUjian = "savedUjian",
  ReadHanjar = "readHanjar",
  SuratKeluarViewMode = "suratKeluarViewMode",
}

export enum SessionStorageKey {
  DataUjian = "dataUjian",
  ResultUjian = "resultUjian",
  ReadHanjar = "readHanjar",
}

export const getLocalStorage = (key: LocalStorageKey, encrypted = false) => {
  if (client) {
    let storage = localStorage.getItem(key);
    if (encrypted && storage) {
      try {
        storage = decrypt(storage);
      } catch (e) {
        if (!isEmpty(storage)) {
          saveLocalStorage(key, storage, encrypted);
        }
      }
    }
    if (storage) return JSON.parse(storage);
    return "";
  }

  return "";
};

export const saveLocalStorage = (
  key: LocalStorageKey,
  data: any,
  encrypted = false
) => {
  if (client) {
    data = JSON.stringify(data);
    if (encrypted) {
      try {
        data = encrypt(data);
      } catch (e) {
        // do nothing
      }
    }
    localStorage.setItem(key, data);
  }
};

export const removeLocalStorage = (key: LocalStorageKey) => {
  if (client) {
    localStorage.removeItem(key);
  }
};

export const getSessionStorage = (key: SessionStorageKey) => {
  if (client) {
    const storage = sessionStorage.getItem(key);
    if (storage) return JSON.parse(storage);
    return "";
  }

  return "";
};

export const saveSessionStorage = (key: SessionStorageKey, data: any) => {
  if (client) {
    sessionStorage.setItem(key, JSON.stringify(data));
  }
};
